import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { v4 as uuid } from 'uuid';
import Modal from '@eika-infrastruktur/ui-modal';

class Input extends Component {

    static propTypes = {
        label: PropTypes.string,
        inputRef: PropTypes.func,
        name: PropTypes.string,
        tooltipText: PropTypes.string,
        modalHelpBody: PropTypes.element,
        modalHelpHeader: PropTypes.string,
        infoLinkLabel: PropTypes.string,
        infoLinkText: PropTypes.string,
        errorText: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        onFocus: PropTypes.func,
        onKeyUp: PropTypes.func,
        min: PropTypes.number,
        max: PropTypes.number,
        step: PropTypes.number,
        type: PropTypes.oneOf(['text', 'number', 'password', 'email', 'range', 'tel', 'url']),
        placeholder: PropTypes.string,
        pattern: PropTypes.string
    };

    static defaultProps = {
        type: 'text'
    };

    constructor(props) {
        super(props);
        this.state = {
            tooltipOpen: false,
            infoLinkOpen: false,
            modalOpen: false
        };
        this.onToggleTooltip = this.onToggleTooltip.bind(this);
        this.onToggleInfoLink = this.onToggleInfoLink.bind(this);
        this.onToggleModal = this.onToggleModal.bind(this);
        this.id = uuid();
    }

    onToggleTooltip(event) {
        event.preventDefault();
        this.setState(prevState => ({
            tooltipOpen: !prevState.tooltipOpen
        }));
    }

    onToggleInfoLink(event) {
        event.preventDefault();
        this.setState(prevState => ({
            infoLinkOpen: !prevState.infoLinkOpen
        }));
    }

    onToggleModal(event) {
        event.preventDefault();
        this.setState(prevState => ({
            modalOpen: !prevState.modalOpen
        }));
    }

    render() {
        const {
            label,
            type,
            name,
            value,
            onChange,
            min,
            max,
            step,
            placeholder,
            pattern,
            tooltipText,
            errorText,
            infoLinkLabel,
            infoLinkText,
            onBlur,
            onFocus,
            onKeyUp,
            modalHelpBody,
            modalHelpHeader,
            inputRef,
            ...rest
        } = this.props;

        let tooltipBox;
        let tooltipIcon;
        let modalBox;

        if (tooltipText && this.state.tooltipOpen) {
            tooltipBox = (
                <div className="input-tooltip">
                    <div className="arrow" />
                    <div className="input-tooltip-box">
                        <div>{tooltipText}</div>
                        <button type="button" className="btn-transparent input-label-close" onClick={this.onToggleTooltip}>
                            <span className="ikon-kryss-24 input-label-close-x" aria-hidden />
                            <span className="input-label-close-text">Lukk</span>
                        </button>
                    </div>
                </div>
            );
        }

        if (tooltipText) {
            tooltipIcon = (
                <button type="button" className="info-button" onClick={this.onToggleTooltip}>
                    <span className="ikon-info-24 label-icon" />
                </button>
            );
        } else if (modalHelpBody && modalHelpHeader) {
            tooltipIcon = (
                <button type="button" className="info-button" onClick={this.onToggleModal}>
                    <span className="ikon-info-24 label-icon" />
                </button>
            );
            modalBox = (
                <Modal
                    headerIcon="ikon-spoersmaalstegn-36"
                    headerText={modalHelpHeader}
                    onClickCallback={this.onToggleModal}
                    showModal={this.state.modalOpen}
                >
                    {modalHelpBody}
                </Modal>
            );
        }

        let infoLink;
        let infoLinkBox;

        if (infoLinkLabel && infoLinkText && this.state.infoLinkOpen) {
            infoLinkBox = (
                <div className="info-link-tooltip">
                    <div className="arrow" />
                    <div className="input-tooltip-box">
                        <div>{infoLinkText}</div>
                        <button type="button" className="btn-transparent input-label-close" onClick={this.onToggleInfoLink}>
                            <span className="ikon-kryss-24 input-label-close-x" aria-hidden />
                            <span className="input-label-close-text">Lukk</span>
                        </button>
                    </div>
                </div>
            );
        }

        if (infoLinkLabel) {
            infoLink = (
                <div className="info-link-wrapper">
                    <button type="button" className="info-button" onClick={this.onToggleInfoLink}>
                        <span className="ikon-spoersmaal-24 info-link-icon" aria-hidden />
                        <span className="info-link-label">{infoLinkLabel}</span>
                    </button>
                    {infoLinkBox}
                </div>
            );
        }

        let errorMessage;

        if (errorText) {
            errorMessage = (
                <div className="input-error-message">
                    <span className="ikon-utropstegn-24 input-error-icon" aria-hidden />
                    {errorText}
                </div>
            );
        }

        const listClassNames = classNames('input-group', { 'input-error': errorText });

        return (
            <div>
                <div className={listClassNames}>
                    <label htmlFor={this.id} className="control-label input-label">
                        {label}
                        {tooltipIcon}
                    </label>
                    {tooltipBox}
                    {modalBox}
                    <input
                        {...rest}
                        id={this.id}
                        className="form-control"
                        ref={inputRef}
                        type={type}
                        name={name}
                        value={value}
                        placeholder={placeholder}
                        pattern={pattern}
                        onChange={onChange}
                        onBlur={onBlur}
                        onFocus={onFocus}
                        onKeyUp={onKeyUp}
                        min={min}
                        max={max}
                        step={step}
                    />
                    {infoLink}
                    {errorMessage}
                </div>
            </div>
        );
    }

}

export default Input;
